<section class="py-4">

  <div class="row mx-2">

    <div class="col-12 col-sm-12 col-xl-3 pb-2 px-3">
      <app-date-interval [(inicio)]="requestData.filter.dataInicio" [(fim)]="requestData.filter.dataFim"></app-date-interval>
    </div>


    <div *ngIf="listaCliente.length>0" class="col-12 col-xl-6 pb-2 px-3">
      <label for="pesquisaConsulta">Cliente</label>

      <div class="row align-items-center">

        <ng-container *ngFor="let c of listaCliente">
          <button *ngIf="c.checked" (click)="removeFiltroCliente(c)" class="btn btn-xs btn-danger btn-icon m-1 flex-fill justify-content-between">
            <span> {{ c.nomeFantasia }}</span>
            <i class="mdi mdi-close"></i>
          </button>
        </ng-container>

        <input [inputFormatter]="inputClienteFormat" (selectItem)="addFiltroCliente($event)" [(ngModel)]="clienteSelecionado" [ngbTypeahead]="pesquisaCliente" [resultTemplate]="rt_cliente"
          id="pesquisaCliente" type="text" class="form-control input-autocomplete">
        <ng-template #rt_cliente let-r="result" let-t="term">
          <ngb-highlight [result]="r.nomeFantasia" [term]="t"></ngb-highlight>
        </ng-template>
      
      </div>

    </div>

    <div *ngIf="listaUnidade.length>0" class="col-12 col-xl-6 pb-2 px-3">
      <label for="pesquisaConsulta">Unidade</label>
      
      <div class="row align-items-center">

        <ng-container *ngFor="let c of listaUnidade">
          <button *ngIf="c.checked" (click)="removeFiltroUnidade(c)" class="btn btn-xs btn-danger btn-icon m-1 flex-fill justify-content-between">
            <span> {{ c.nomeFantasia }}</span>
            <i class="mdi mdi-close"></i>
          </button>
        </ng-container>

        <input [inputFormatter]="inputUnidadeFormat" (selectItem)="addFiltroUnidade($event)" [(ngModel)]="unidadeSelecionado" [ngbTypeahead]="pesquisaUnidade" [resultTemplate]="rt_Unidade"
          id="pesquisaUnidade" type="text" class="form-control input-autocomplete">
        <ng-template #rt_Unidade let-r="result" let-t="term">
          <ngb-highlight [result]="r.nomeFantasia" [term]="t"></ngb-highlight>
        </ng-template>
      
      </div>

    </div>

  </div>

  <div class="row mx-2">
    <div class="mx-4">
      <button (click)="getResultado()" class="btn btn-success btn-icon">
        <i class="mdi mdi-magnify"></i>
        <span>Filtrar</span>
      </button>
    </div>

    <div class="mx-4">
      <button (click)="download()" class="btn btn-success btn-icon">
        <i class="mdi mdi-download"></i>
        <span>Download Excel</span>
      </button>
    </div>
</div>

  <div *ngIf="tableLoading" class="m-4 card">
    <div class="p-5 d-flex justify-content-center position-relative">
      <i class="mdi mdi-loading rotate-animation f-80 text-primary"></i>
    </div>
  </div>

  <div *ngIf="!tableLoading" class="mx-2 my-4 mx-lg-4 card">
    <div class="table-responsive">
      <table class="table table-striped table-hover">
        <thead>
          <tr>
            <th [tableOrderGroup]="requestData.sorting" [(tableOrder)]="requestData.sorting.id" (tableOrderChange)="setTableOrder()">Id</th>
            <th>CNPJ</th>
            <th [tableOrderGroup]="requestData.sorting" [(tableOrder)]="requestData.sorting.nomeFantasia" (tableOrderChange)="setTableOrder()">Nome</th>
            <th [tableOrderGroup]="requestData.sorting" [(tableOrder)]="requestData.sorting.usuario" (tableOrderChange)="setTableOrder()">Usuário</th>
            <th [tableOrderGroup]="requestData.sorting" [(tableOrder)]="requestData.sorting.produto" (tableOrderChange)="setTableOrder()">Consulta</th>
            <th [tableOrderGroup]="requestData.sorting" [(tableOrder)]="requestData.sorting.data" (tableOrderChange)="setTableOrder()">Data</th>
            <th [tableOrderGroup]="requestData.sorting" [(tableOrder)]="requestData.sorting.entrada" (tableOrderChange)="setTableOrder()">Entrada</th>
            <th [tableOrderGroup]="requestData.sorting" [(tableOrder)]="requestData.sorting.cobrar" (tableOrderChange)="setTableOrder()">Cobrar</th>
            <th [tableOrderGroup]="requestData.sorting" [(tableOrder)]="requestData.sorting.resgatada" (tableOrderChange)="setTableOrder()">Resgatada</th>
            <th [tableOrderGroup]="requestData.sorting" [(tableOrder)]="requestData.sorting.laudo" (tableOrderChange)="setTableOrder()">Laudo</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="listaResultado.length==0">
            <td class="text-center py-5 text-secondary w-500" colspan="10">
              Sem registros
            </td>
          </tr>
          <tr *ngFor="let r of listaResultado">
            <td class="text-center">{{r.id}}</td>
            <td class="text-center">{{r.documento}}</td>
            <td class="text-center">{{r.razaoSocial || r.nomeFantasia}}</td>
            <td class="text-center">{{r.login}}</td>
            <td class="text-center">{{r.nomeConsulta}}</td>
            <td class="text-center">{{r.dataConsulta | date:'dd/MM/yyyy HH:mm:ss'}}</td>
            <td class="text-center">{{r.entrada}}</td>
            <td class="text-center">{{r.cobrar}}</td>
            <td class="text-center">{{r.resgatada}}</td>
            <td class="text-center">{{r.laudo}}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="card-footer bg-white d-flex justify-content-between">
      <ngb-pagination [pageSize]="requestData.per_page" [boundaryLinks]="true" [collectionSize]="total" [(page)]="requestData.page" (pageChange)="pageChange()" [maxSize]="5" [rotate]="true">
      </ngb-pagination>

      <div class="btn-group" role="group" aria-label="Basic example">
        <button [disabled]="total==0" (click)="setPageSize(10)" [ngClass]="{'active':  requestData.per_page==10}" type="button" class="btn btn-outline-primary">10</button>
        <button [disabled]="total==0" (click)="setPageSize(25)" [ngClass]="{'active':  requestData.per_page==25}" type="button" class="btn btn-outline-primary">25</button>
        <button [disabled]="total==0" (click)="setPageSize(50)" [ngClass]="{'active':  requestData.per_page==50}" type="button" class="btn btn-outline-primary">50</button>
        <button [disabled]="total==0" (click)="setPageSize(100)" [ngClass]="{'active': requestData.per_page==100}" type="button" class="btn btn-outline-primary">100</button>
      </div>
    </div>
  </div>

</section>